import react from "../../assets/imgs/react.png";
import node from "../../assets/imgs/node.png";
import native from "../../assets/imgs/native.png";
import js from "../../assets/imgs/js.png";
import mongo from "../../assets/imgs/mongo.png";
import sql from "../../assets/imgs/sql.png";
import python from "../../assets/imgs/python.png";
import figma from "../../assets/imgs/figma.png";
import illustrator from "../../assets/imgs/illustrator.png";
import photoshop from "../../assets/imgs/photoshop.png";
import redux from "../../assets/imgs/redux.png";
import tail from "../../assets/imgs/tail.png";
import gcp from "../../assets/imgs/gcp.png";
import nest from "../../assets/imgs/nest.png";
import types from "../../assets/imgs/type.png";
import next from "../../assets/imgs/next-js.png";

const skills = [
    {
        name: "React.js",
        icon: react,
        desc: "React.js, commonly known as React, is a JavaScript library for building user interfaces, particularly for single-page applications where the content is updated dynamically without requiring a full page reload. It was developed by Facebook and is widely used for building modern web applications.",
    },
    {
        name: "Node.js",
        icon: node,
        desc: "Node.js is a server-side JavaScript runtime that allows developers to build scalable and high-performance network applications. It is built on the V8 JavaScript runtime engine, the same engine that powers the Google Chrome browser.",
    },
    {
        name: "R. Native",
        icon: native,
        desc: "React Native is an open-source framework developed by Facebook that allows developers to build mobile applications using JavaScript and React. It leverages the React library for building user interfaces and extends it to work with native mobile components.",
    },
    {
        name: "NestJS",
        icon: nest,
        desc: "NestJS is a TypeScript-based open-source framework for building scalable and maintainable server-side applications. It is built on top of Node.js and leverages concepts from both object-oriented programming and functional programming.",
    },
    {
        name: "Next.js",
        icon: next,
        desc: "Next.js is a React-based open-source framework for building modern web applications. It is developed by Vercel and is designed to make it easier to create production-ready React applications with features like server-side rendering, automatic code splitting, and simplified routing.",
    },
    {
        name: "TypeScript",
        icon: types,
        desc: "TypeScript is a superset of JavaScript that adds static typing to the language. It is an open-source programming language developed by Microsoft and widely used for building large-scale applications.",
    },
    {
        name: "JavaScript",
        icon: js,
        desc: "JavaScript is a high-level, dynamic, and versatile programming language that is primarily used for building dynamic and interactive web applications. It is a core technology for web development and is supported by all modern web browsers.",
    },
    {
        name: "MongoDB",
        icon: mongo,
        desc: "MongoDB is a popular open-source NoSQL database management system that is designed to store, retrieve, and manage data in a flexible, scalable, and high-performance manner."
    },
    {
        name: "MySQL",
        icon: sql,
        desc: "MySQL is an open-source relational database management system (RDBMS) that is widely used for managing and organizing structured data."
    },
    {
        name: "Redux",
        icon: redux,
        desc: "Redux is a predictable state container for JavaScript applications, commonly used with React for managing the state of an application in a predictable and centralized manner."
    },
    {
        name: "Tailwind",
        icon: tail,
        desc: "Tailwind CSS is a utility-first CSS framework that provides a set of low-level utility classes to build designs directly in your markup. It aims to provide a highly customizable and efficient way to style web applications."
    },
    {
        name: "GCP",
        icon: gcp,
        desc: "Google Cloud Platform (GCP) is a suite of cloud computing services provided by Google. It offers a wide range of infrastructure and platform services for computing, storage, data analytics, machine learning, networking, and more."
    },
    {
        name: "Figma",
        icon: figma,
        desc: "Figma is a collaborative cloud-based design tool that is used for creating user interfaces, prototypes, and collaborative design projects. It's particularly popular among UX/UI designers and design teams."
    },
    {
        name: "Illustrator",
        icon: illustrator,
        desc: "Adobe Illustrator is a vector graphics editor developed and marketed by Adobe Inc. It is widely used by graphic designers, illustrators, and artists for creating vector-based artwork."
    },
    {
        name: "Photoshop",
        icon: photoshop,
        desc: "Adobe Photoshop is a raster graphics editor developed by Adobe Inc. It is widely used for image editing, graphic design, and digital art creation."
    },
    {
        name: "Python",
        icon: python,
        desc: "Python is a high-level, interpreted programming language celebrated for its readability, simplicity, and versatility. Its design philosophy prioritizes code readability and a clean syntax, making it an excellent choice for beginners and experienced developers alike."
    },
];

export default skills;
